import { render } from "./twelve-pricing.vue?vue&type=template&id=2bc7d113"
import script from "./twelve-pricing.vue?vue&type=script&lang=js"
export * from "./twelve-pricing.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__